import content from "app-content";
import { SIZE_PICKER_DEFAULT_VALUE } from "../constants";
import productHasAlternatePrices from "../../productHasAlternatePrices";
import getOption from "../../getOption";
import getOptionText from "./getOptionText";

const getOptions = ({ isOneSize, isNoSize, variants, variantId }) => {
  if (isNoSize) {
    return [getOption(content.saved_items_item_prompt_no_size, `${variantId}`)];
  } else if (isOneSize) {
    return [getOption(content.saved_items_one_size, `${variantId}`)];
  }

  const hasAlternatePrices = productHasAlternatePrices(variants);

  const variantOptions = variants.map(
    ({ displaySizeText, price, isVariantInStock, id }) =>
      getOption(
        getOptionText({
          size: displaySizeText,
          price: hasAlternatePrices ? price : undefined,
          isVariantInStock
        }),
        `${id}`
      )
  );

  return [
    ...(variantId === null
      ? [
          getOption(
            content.saved_items_item_prompt_select_size,
            SIZE_PICKER_DEFAULT_VALUE
          )
        ]
      : []),
    ...variantOptions
  ];
};

export default getOptions;
